<template>
  <div>
    <div class="quiz-student-topbar fixed-top quiz-student-topbar--lg">
      <StudioLogo
        v-if="studio"
        class="logo-image mx-2 mx-lg-4"
        :studio="studio"
      />
      <div class="flex-item mr-4">
        <span v-if="solvedQuizProp">
          {{ $t('QUIZZES.TEXT.QUESTION') }}
          <span class="font-weight-bold"
            >{{ currentQuestionIndexProp }} {{ $t('QUIZZES.TEXT.OF') }}
            {{ solvedQuizProp.quiz.quiz_questions.length }}</span
          >
        </span>
        <HMButton class="ml-4" color="outline-gray" @click="leaveQuiz">
          {{ $t('QUIZZES.BUTTON.LEAVE') }}
        </HMButton>
      </div>
    </div>
    <div class="container mt-4">
      <Quiz
        :studioURL="studioURL"
        :quizId="parseInt($route.params.quiz_id)"
        @solvedQuiz="getsolvedQuizProp"
        @quizInfo="quizInfo"
        @currentQuestionIndex="getCurrentQuestionIndexProp"
        @close="leave"
        @finish="leave"
        @screenTypeChanged="type => (currentScreenType = type)"
      />
      <div class="page-bottom-filler"></div>
      <HMMadeBy class="footer-fixed" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Quiz from '@/web/components/quizzes/Quiz.vue';
import StudioLogo from '@/web/components/navigation/StudioLogo.vue';
import { mapGetters } from 'vuex';
import HMDialog from '@/web/components/common/HMDialog.vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { quizOrQuestionnaire } from '@/core/utils/quizzes';

export default Vue.extend({
  name: 'StudioQuiz',
  components: {
    Quiz,
    StudioLogo,
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    isGradable() {
      return this.quiz?.is_gradable;
    },
  },
  data() {
    return {
      solvedQuizProp: null,
      currentQuestionIndexProp: 1,
      quiz: null,
      currentScreenType: null,
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch('studio/getStudio', this.studioURL);
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('STUDIO.NOTIFICATIONS.LOAD_STUDIO_ERROR'),
        text: `Error: ${error}`,
        duration: -1,
      });
    }
  },
  methods: {
    quizOrQuestionnaire,
    quizInfo(value) {
      this.quiz = value;
    },
    getsolvedQuizProp(value) {
      this.solvedQuizProp = value;
    },
    getCurrentQuestionIndexProp(value) {
      this.currentQuestionIndexProp = value;
    },
    leave() {
      this.$router.push({ name: 'studio-home' });
    },
    leaveQuiz() {
      if (this.currentScreenType !== 'questions') {
        this.leave();
        return;
      }
      this.$modal.show(HMDialog, {
        title: this.$t('QUIZZES.TITLE.EXIT_QUIZ'),
        subtitle: this.$t('GENERAL.TEXT.DO_YOU_REALLY_WANT_TO_DO_IT'),
        text: this.$t(
          `QUIZZES.TEXT.ONLY_ANSWERED_ANSWERS_WILL_BE_SUBMITTED_${quizOrQuestionnaire(
            this.isGradable
          )}`
        ),
        confirmButton: this.$t('QUIZZES.BUTTON.DISCARD'),
        discardButton: this.$t('QUIZZES.BUTTON.STAY_ON_PAGE'),
        discard: () => {
          console.log('confirmed');
        },
        confirm: () => this.leave(),
      });
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: $shop-footer-height;
  line-height: $shop-footer-height;
  background-color: $white;
  z-index: $zindex-fixed;
  font-size: 10px;

  @include media-breakpoint-down(md) {
    font-size: 10px;
  }
}

.container {
  position: relative;
  top: 202px;
}

.quiz-student-topbar {
  display: flex;
  justify-content: space-between;
  background-color: white !important;
  color: $charcoal;
  padding: 0 0.5rem;
  height: $shop-topbar-height;
  align-items: stretch;
  transition: height 0.2s ease-out;
  box-shadow: 0px 1px 5px rgba(50, 50, 50, 0.2);

  &--lg {
    @include media-breakpoint-up(md) {
      height: $shop-topbar-lg-height;
      box-shadow: none;
      transition: height 0.2s ease-out;
    }
  }

  .logo-image {
    ::v-deep img {
      padding: 0.5rem 0;
      max-width: 150px;
      @include media-breakpoint-up(md) {
        max-width: 300px;
      }
    }
  }
}

.flex-item {
  display: flex;
  align-items: center;
}
</style>
